<!-- 头部导航 -->
<template>
  <div class="topNav_box" style="display: flex; align-items: center">
    <div class="container" style="height: 64px">
      <div class="f-b-c" style="width: 100%; height: 100%">
        <a href="/" class="logo f-s-c">
          <img src="@/assets/img/logog.png" alt="" style="height: 32px" />
        </a>
        <div v-show="isShowSearch || routerName != 'homeLayout'">
          <div class="search bar">
            <form class="f-s-c">
              <input
                type="text"
                v-model="topSearchContent"
                placeholder="请输入您要搜索的公司..."
              />
              <button type="submit" @click="topSearch()"></button>
            </form>
          </div>
        </div>
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <div class="navs-list f-c-c">
            <router-link
              to="/homeLayout"
              class="nav_item"
              :class="{ on_nav_item: routerName == 'homeLayout' }"
              >首页</router-link
            >

            <el-dropdown>
              <span class="el-dropdown-link">
                <!--       to="/apply" -->
                <router-link
                  to=""
                  class="nav_item"
                  :class="{ on_nav_item: routerName == 'apply' }"
                  >应用
                  <i class="el-icon-caret-bottom" style="margin-left: 5px"></i
                ></router-link>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div class="apply_dropdown">
                  <div
                    style="
                      display: flex;
                      border-bottom: 1px solid rgb(214 214 207);
                      justify-content: center;
                    "
                  >
                    <img
                      src="@/assets/img/wkd-logo.png"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <div>微客抖</div>
                  </div>
                  <div style="display: flex">
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        flex: 1;
                      "
                    >
                      <img
                        src="@/assets/img/android_ewm.png"
                        alt=""
                        width="60px"
                        height="60px"
                      />
                      <div style="font-size: 13px">安卓下载</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        flex: 1;
                      "
                    >
                      <img
                        src="@/assets/img/ios_ewm.png"
                        alt=""
                        width="60px"
                        height="60px"
                      />
                      <div style="font-size: 13px">ios下载</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;
                        flex: 1;
                      "
                    >
                      <a href="https://www.jshks.com/assets/wkd-lastest.exe">
                        <el-button type="primary" size="mini"
                          >Mac<i class="el-icon-download el-icon--right"></i
                        ></el-button>
                      </a>
                      <a href="https://www.jshks.com/assets/wkd-lastest.dmg">
                        <el-button
                          type="primary"
                          size="mini"
                          style="margin-left: 0px"
                          >Win<i class="el-icon-download el-icon--right"></i
                        ></el-button>
                      </a>
                    </div>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- /solution -->
            <router-link
              to=""
              v-if="false"
              class="nav_item"
              :class="{ on_nav_item: routerName == 'solution' }"
              >解决方案
              <i class="el-icon-caret-bottom" style="margin-left: 5px"></i
            ></router-link>
            <el-dropdown>
              <span class="el-dropdown-link">
                <!-- /product -->
                <router-link
                  to=""
                  class="nav_item"
                  :class="{ on_nav_item: routerName == 'product' }"
                  >产品
                  <i class="el-icon-caret-bottom" style="margin-left: 5px"></i
                ></router-link>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div class="apply_dropdown">
                  <div
                    style="
                      display: flex;
                      border-bottom: 1px solid rgb(214 214 207);
                      justify-content: center;
                    "
                  >
                    <img
                      src="@/assets/img/wkd-logo.png"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <div>微客抖</div>
                  </div>
                  <div style="display: flex">
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        flex: 1;
                      "
                    >
                      <img
                        src="@/assets/img/android_ewm.png"
                        alt=""
                        width="60px"
                        height="60px"
                      />
                      <div style="font-size: 13px">安卓下载</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        flex: 1;
                      "
                    >
                      <img
                        src="@/assets/img/ios_ewm.png"
                        alt=""
                        width="60px"
                        height="60px"
                      />
                      <div style="font-size: 13px">ios下载</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;
                        flex: 1;
                      "
                    >
                      <a href="https://www.jshks.com/assets/wkd-lastest.exe">
                        <el-button type="primary" size="mini"
                          >Mac<i class="el-icon-download el-icon--right"></i
                        ></el-button>
                      </a>
                      <a href="https://www.jshks.com/assets/wkd-lastest.dmg">
                        <el-button
                          type="primary"
                          size="mini"
                          style="margin-left: 0px"
                          >Win<i class="el-icon-download el-icon--right"></i
                        ></el-button>
                      </a>
                    </div>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- /setMeal -->
            <router-link
              to="/setMeal"
              class="nav_item"
              :class="{ on_nav_item: routerName == 'setMeal' }"
              ><img
                src="@/assets/img/header-vip-sid.png"
                style="width: 75%"
                alt=""
                srcset=""
            /></router-link>
            <router-link
              to="/mall"
              class="nav_item"
              :class="{ on_nav_item: routerName == 'mall' }"
              >积分商城</router-link
            >
            <router-link
              to="/map"
              class="nav_item"
              :class="{ on_nav_item: routerName == 'map' }"
              >地图</router-link
            >
          </div>
          <div class="logo f-e-c" v-if="isLogin">
            <img
              src="@/assets/img/de-avatar.jpg"
              alt=""
              style="
                border-radius: 50%;
                margin-right: 10px;
                width: 32px;
                height: 32px;
                object-fit: cover;
              "
            />
            <span style="font-size: 15px; font-weight: 400; color: #222222">{{
              userData.uname
            }}</span>
            <a
              href="javascript:;"
              @click="funcLogout()"
              class="wkd-btn black small"
              style="margin-left: 10px;width: fit-content;"
              >退出</a
            >
          </div>
          <div class="logo f-e-c" v-else>
            <router-link
              to="/register"
              class="wkd-btn"
              style="margin-right: 10px; background-color: rgb(255 165 0)"
              >注册</router-link
            >
            <router-link to="/login" class="wkd-btn">登录</router-link>
          </div>
        </div>
      </div>
    </div>
    <el-switch
      style="display: block; min-width: 300px; margin-left: 16px"
      v-model="foreign"
      active-value="2"
      inactive-value="1"
      @change="switchChange"
      active-color="#13ce66"
      inactive-color="#ff4949"
      active-text="国际数据"
      inactive-text="国内数据"
    >
    </el-switch>
  </div>
</template>
<script >
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      foreign: 1,
      routerName: this.$route.name,
      isShowSearch: false,
      topSearchContent: "",
    };
  },
  props: [],
  computed: {
    ...mapGetters(["isLogin", "userData"]),
  },
  watch: {
    $route(to, from) {
      //监听路由name，操作导航栏样式
      this.routerName = to.name;
    },
  },
  components: {},
  created() {
    //获取本地存储的旧数据
    const userData = localStorage.getItem("userData");
    if (userData != null) {
      let newUserData = JSON.parse(userData);
      this.$store.commit("SET_IS_LOGIN", true); //修改登录状态
      this.$store.commit("SET_USER_DATA", newUserData); //vuex登录消息
    }
  },
  mounted() {
    this.SearchEvent();
  },
  methods: {
    switchChange(val) {
      if (val == 1) {
        this.$message({
          message: "已切换为国内数据",
          type: "success",
        });
      } else {
        this.$message({
          message: "已切换为国际数据",
          type: "success",
        });
      }
      this.$store.commit("SET_FOREIFN", val);
      console.log(val);
    },
    funcLogout() {
      this.$store.commit("SET_IS_LOGIN", false); //修改登录状态
    },
    topSearch() {
      if (this.$route.name != "homeLayout") {
        this.$router.push({
          name: "homeLayout",
          params: {
            id: this.topSearchContent,
          },
        });
      } else {
        this.$store.commit("SET_TOP_SEARCH", this.topSearchContent);
      }
      this.topSearchContent = "";
    },
    SearchEvent() {
      document.addEventListener("scroll", (e) => {
        this.scroll = document.documentElement.scrollTop;
        if (this.scroll >= 240) {
          this.isShowSearch = true;
        } else {
          this.isShowSearch = false;
        }
      });
    },
  },
};
</script>
<style lang='less'>
.topNav_box {
  background-color: #ffffff;
  width: 100%;
  height: 64px;
  .container {
    max-width: 1170px;
    min-width: 1170px;
    padding-right: 15px;
    padding-left: 15px;
    // margin-right: auto;
    margin-left: auto;
    .f-b-c {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bar {
        background: #ffffff;
        margin-top: 0;
      }
      .bar input {
        border: 2px solid #0089ff;
        border-right: 1px transparent;
        border-radius: 5px 0px 0px 5px;
        background: transparent;
        height: 35px;
        width: 220px;
        outline: none;
        padding: 0px 6px;
      }
      .bar button {
        background: #0089ff;
        border-radius: 0 5px 5px 0;
        border: 2px solid #0089ff;
        border-left: 1px transparent;
        width: 60px;
        height: 35px;
        cursor: pointer;
      }
      .bar button:before {
        content: "搜索";
        font-size: 13px;
        color: #ffffff;
      }
    }
    .f-c-c {
      display: flex;
      justify-content: center;
      align-items: center;
      .nav_item {
        i {
          transition: 0.3s ease-in-out;
        }
        &:hover {
          color: #0c8fff;
          font-weight: 600;
          i {
            color: #0c8fff;
            font-weight: 600;
            transform: rotate(180deg);
          }
        }
      }
      .on_nav_item {
        color: #0c8fff;
        font-weight: 600;
      }
    }
    .f-e-c {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .wkd-btn {
      color: #ffffff;
      cursor: pointer;
      width: 100%;
      padding: 10px 15px;
      height: 36px;
      background-color: rgb(0 137 255);
      border-radius: 6px;
      border: 0 solid rgb(0 137 255);
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .navs-list {
      height: 100%;
      margin-right: 20px;
      margin-top: 0;
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #222222;
        height: 100%;
        font-size: 14px;
        padding: 0px 10px;
        border-right: 1px solid #e0dede;
      }
    }
  }
}
.product_dropdown {
  width: 230px;
  height: 160px;
}
.apply_dropdown {
  width: 230px;
  height: 160px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>